/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-02 11:17:21
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-17 10:22:13
 */
/*
 * @params routes 菜单路由数组
 *
 */
// export const filterRouter = (routes) => {
//   // 遍历后台传来的路由字符串，转换为组件对象
//   const accessedRouters = routes.filter(route => {
//     if (route.component) {
//       route.component = _import(route.component)
//     }
//     if (route.children && route.children.length) {
//       route.children = filterRouter(route.children)
//     }
//     return true
//   })
//   return accessedRouters
// }
export const filterRouter = (routes) => {
        // 遍历后台传来的路由字符串，转换为组件对象
        const accessedRouters = routes.filter(route => {
            if (route.component) {
                route.component = _import(route.button_component)
            }
            if (route.menus_tree && route.menus_tree.length) {
                route.children = filterRouter(route.menus_tree)
            }
            return true
        })
        return accessedRouters
    }
    // 文件项目路径 
function _import(file) {
    return () =>
        import ('@/' + file)
}